// ----------------------------------------------------------------------------
// Snippet: Card
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/_containers/css-grid/css-grid';
import 'snippets/background-media/background-media';
import 'snippets/card-label/card-label';

// Styles
import './_card.scss';

// variables
var CARD_PRODUCT = '.card--product';
var CARD_IMAGE_WRAPPER = '.card__image-wrapper';
var CARD_PRODUCT_IMAGE = '.card__product-image';
var CARD_COLOR_OPTION = '.card__swatch--color-option';
var CARD_COLOR_SWATCHES = '.card__color-swatches';
var SELECTED_CLASS_NAME = 'selected';
function changeSwatch(swatchOption) {
  // Update selected state
  if (!swatchOption.classList.contains(SELECTED_CLASS_NAME)) {
    swatchOption.closest(CARD_COLOR_SWATCHES).querySelector(".".concat(SELECTED_CLASS_NAME)).classList.remove(SELECTED_CLASS_NAME);
    swatchOption.classList.add(SELECTED_CLASS_NAME);
    var newImageSrc = swatchOption.dataset.imageSrc;
    if (newImageSrc !== undefined) {
      // Get additional src and srcset
      var newDesktopMedia = swatchOption.dataset.desktopMedia;
      var newDesktopSrcset = swatchOption.dataset.desktopSrcset;
      var newMobileSrcset = swatchOption.dataset.mobileSrcset;
      var newImageSrcset = swatchOption.dataset.imageSrcset;
      var productCard = swatchOption.closest(CARD_PRODUCT);
      var productCardImageWrapper = productCard.querySelector(CARD_IMAGE_WRAPPER);
      var productCardPicture = productCardImageWrapper.querySelector('picture');
      var productCardPictureImage = productCardPicture.querySelector(CARD_PRODUCT_IMAGE);

      // Update desktop and mobile src
      productCardPicture.querySelectorAll('source').forEach((source, index) => {
        switch (index) {
          case 0:
            // Desktop Source
            source.media = newDesktopMedia;
            source.srcset = newDesktopSrcset;
            break;
          case 1:
            // Mobile Source
            source.srcset = newMobileSrcset;
            break;
          default:
            break;
        }
      });

      // Update image src
      productCardPictureImage.src = newImageSrc;
      productCardPictureImage.srcset = newImageSrcset;
    }
  }
}
document.querySelectorAll(CARD_COLOR_OPTION).forEach(element => {
  element.addEventListener('click', element => {
    element.stopPropagation();
    var selectedSwatchOption = element.currentTarget;
    changeSwatch(selectedSwatchOption);
  });
  element.addEventListener('keydown', element => {
    element.stopPropagation();
    if (element.key === 'Enter') {
      var selectedSwatchOption = element.currentTarget;
      changeSwatch(selectedSwatchOption);
    }
  });
});